import nanoid from 'nanoid'
import { fetchCurrentFooter } from '../../../options/options/ct-footer-builder'
import { getOriginalId, customItemsSeparator } from '../placements/helpers'

const transformColumns = (columns, futureLength) => {
	columns = columns.filter((c) => c.length > 0)

	return Array.from(Array(futureLength)).map((_, index) => {
		if (Array.isArray(columns[index])) {
			return columns[index]
		}

		return []
	})
}

export const builderReducer = (builderValue, action) => {
	let updatedGlobalState = {}
	let newSections = []

	let futureBuilderValue = builderValue.sections.find(
		({ id }) =>
			id.indexOf(
				builderValue.__forced_static_footer__ ||
					fetchCurrentFooter() ||
					builderValue.sections[0].id
			) > -1
	)

	let shouldUpdate = false
	let updateItemId = false
	let removeSectionIds = []

	if (action.type === 'BUILDER_GLOBAL_SETTING_ON_CHANGE') {
		const { optionId, optionValue, values = {} } = action.payload

		futureBuilderValue = {
			...futureBuilderValue,
			settings: {
				...futureBuilderValue.settings,
				[optionId]: optionValue,
			},
		}
	}

	if (action.type === 'ITEM_VALUE_ON_CHANGE') {
		const { id, optionId, optionValue, values = {} } = action.payload

		updateItemId = `${id}:${optionId}`

		let items = futureBuilderValue.items

		if (
			(id === 'top-row' || id === 'middle-row' || id === 'bottom-row') &&
			optionId === 'items_per_row'
		) {
			futureBuilderValue = {
				...futureBuilderValue,
				rows: futureBuilderValue.rows.map((row) =>
					row.id === id
						? {
								...row,
								columns: transformColumns(
									row.columns,
									parseInt(optionValue, 10)
								),
						  }
						: row
				),
			}
		} else {
			if (!items[id]) {
				items[id] = {
					id,
					values: {},
				}
			}

			futureBuilderValue = {
				...futureBuilderValue,
				items: {
					...(Array.isArray(items) ? {} : items),
					[id]: {
						id,
						values: {
							...items[id].values,
							[optionId]: optionValue,
						},
					},
				},
			}
		}
	}

	if (action.type === 'REMOVE_CLONED_ITEM') {
		let {
			[action.payload.id]: removedItem,
			...localItems
		} = futureBuilderValue.items

		futureBuilderValue = {
			...futureBuilderValue,
			items: localItems,
		}
	}

	if (action.type === 'CLONE_ITEM') {
		const futureId = getOriginalId(action.payload.id)

		let completeFutureId = `${futureId}${customItemsSeparator()}${nanoid()}`

		futureBuilderValue = {
			...futureBuilderValue,
			items: {
				...futureBuilderValue.items,
				[completeFutureId]: {
					id: completeFutureId,
					values: futureBuilderValue.items[futureId]
						? futureBuilderValue.items[futureId].values || {}
						: {},
				},
			},
		}
	}

	if (action.type === 'PICK_BUILDER_SECTION') {
		shouldUpdate = true
		updatedGlobalState = { __forced_static_footer__: action.payload.id }
	}

	if (action.type === 'MARK_FOOTER_AS_GLOBAL') {
		shouldUpdate = true

		updatedGlobalState = {
			__forced_static_footer__: action.payload.id,
			current_section: action.payload.id,
		}
	}

	if (action.type === 'MARK_SPECIFIC_FOOTER_AS_GLOBAL') {
		updatedGlobalState = {
			current_section: action.payload.id,
		}
	}

	if (action.type === 'SET_LIST') {
		shouldUpdate = true
		const { lists } = action.payload

		futureBuilderValue = {
			...futureBuilderValue,
			rows: futureBuilderValue.rows.map(({ id: barId, columns }) => {
				const keys = Object.keys(lists)

				if (keys.map((k) => k.split(':')[0]).indexOf(barId) > -1) {
					return {
						id: barId,
						columns: columns.map((column, index) => {
							if (lists[`${barId}:${index}`]) {
								return lists[`${barId}:${index}`]
							}

							return column
						}),
					}
				}

				return {
					id: barId,
					columns,
				}
			}),
		}
	}

	if (action.type === 'CREATE_NEW_SECTION') {
		const { name, copy } = action.payload

		newSections = [
			copy
				? {
						...(builderValue.sections.find(
							({ id }) => id === copy
						) || {}),

						name,
						id: `ct-custom-${nanoid()}`,
				  }
				: {
						name,
						id: `ct-custom-${nanoid()}`,
						mode: 'columns',
						rows: [
							{
								id: 'top-row',
								columns: [[], []],
							},
							{
								id: 'middle-row',
								columns: [[], [], []],
							},
							{
								id: 'bottom-row',
								columns: [['copyright']],
							},
						],
						items: [],
						settings: [],
				  },
		]
	}

	if (action.type === 'REMOVE_BUILDER_SECTION') {
		removeSectionIds.push(action.payload.id)
	}

	const actualBuilderValue = {
		...builderValue,
		...updatedGlobalState,
		__should_refresh__: shouldUpdate,
		__should_refresh_item__: updateItemId,
		sections: [
			...builderValue.sections.map((builder) =>
				builder.id === futureBuilderValue.id
					? futureBuilderValue
					: builder
			),
			...newSections,
		].filter(({ id }) => removeSectionIds.indexOf(id) === -1),
	}

	return actualBuilderValue
}
